// src/encounter/inserted-templates/inserted-templates-context.ts
// The controller of the added templates, shared by the host (which runs it) and the panel and the "/" menu (which read it).
import { createContext, useContext } from 'react';
import type { InsertedTemplates } from './use-inserted-templates';

export const InsertedTemplatesContext = createContext<InsertedTemplates | null>(null);

/** The controller, or null outside a host (no config: nothing to insert, nothing to show). */
export function useInsertedTemplatesContext(): InsertedTemplates | null {
  return useContext(InsertedTemplatesContext);
}
